import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";

export default function AuditLog() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/audit").then((r) => setRows(r.data || [])); }, []);
  return (
    <div className="space-y-4">
      <h1 className="font-display text-2xl font-bold tracking-tight">Audit Log</h1>
      <Card className="border border-slate-200 overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-slate-900 text-white text-[11px] uppercase tracking-wider">
              <th className="text-left px-4 py-2.5">When</th>
              <th className="text-left px-4 py-2.5">Action</th>
              <th className="text-left px-4 py-2.5">Actor</th>
              <th className="text-left px-4 py-2.5">Detail</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={4} className="text-center py-8 text-slate-400 text-sm">No activity yet</td></tr>}
            {rows.map((r) => (
              <tr key={r.id} className="border-t border-slate-100 hover:bg-slate-50">
                <td className="px-4 py-2 font-mono text-xs text-slate-500">{(r.at || "").replace("T", " ").slice(0, 19)}</td>
                <td className="px-4 py-2"><span className="text-[10px] font-semibold uppercase tracking-wider px-2 py-0.5 rounded bg-blue-50 text-blue-700 border border-blue-100">{r.action}</span></td>
                <td className="px-4 py-2 text-xs">{r.actor}</td>
                <td className="px-4 py-2 text-xs font-mono text-slate-600">{r.detail}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
